import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { popperInDialogZIndex } from '../../../theme/z-index';

export const useAutocompleteStyles = makeStyles<Theme, { disableClearable: boolean }>({
  inputRoot: {
    paddingRight(props) {
      return props.disableClearable ? '0 !important' : 30;
    },
    fontSize: '14px'
  },
  endAdornment: {
    position: 'relative',
    display: 'block',
    width: '40px',
    paddingLeft: '16px',
    cursor: 'pointer'
  },
  endAdornmentClearButton: {
    position: 'absolute',
    left: 0,
    top: 0,
    marginTop: '-10px'
  }
});

/** See popperInDialogZIndex: MUI ties the popper with the dialog, and a tie is not a guarantee. */
export const useAutocompletePopperStyles = makeStyles((theme: Theme) => ({
  popper: {
    zIndex: popperInDialogZIndex(theme)
  }
}));
